<template>
  <div class="footer">
    <div class="footer-part1">
      <img :src="logo" class="logo-hd" />
      <div class="footer-part1-2">
        <div v-if="!isMobile" class="links-more more-wrapper">
          <h3 class="title">{{ brandName }}</h3>
          <ul class="links-more-lists">
            <li>
              <a @click="jump('rules')" href="javascript:;">{{ legalTitles.conduct }}</a>
            </li>
            <li>
              <a @click="jump('terms')" href="javascript:;">{{ legalTitles.tos }}</a>
            </li>
            <li>
              <a @click="jump('policy')" href="javascript:;">{{ legalTitles.privacy }}</a>
            </li>
          </ul>
        </div>
        <div class="contact-more more-wrapper">
          <h3 class="title">Contact Us</h3>
          <ul class="contact-lists">
            <li>
              <p>Email: {{ email }}</p>
            </li>
            <li>
              <p>Contact Center: {{ phone }}</p>
            </li>
            <li>
              <p>Office Address: {{ address }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <p class="footer-part2">
      {{ copyRight }}
    </p>
  </div>
</template>

<script>
import { legalTitles } from '@/legal'
import env from "../assets/js/env";
export default {
  data() {
    return {
      legalTitles: legalTitles(),
      logo: env.logo,
      isMobile: false,
      companyName: env.companyName,
      brandName: env.brandName,
      email: env.email,
      phone: env.phone,
      address: env.address,
      copyRight: env.copyRight,
      channelList: [
      ],
      channelMobileList: [
      ],
      currency: this.$store.state.orderInfo.gameCurrency,
    }
  },
  mounted() {
    this.loadChannelList()
    // if (this._isMobile()) {
    //   this.isMobile = true
    // } else {
    //   this.isMobile = false
    // }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    jump(path) {
      this.$router.push({
        path: `/${path}`
      })
    },

    loadChannelList(){
      if(this.currency == "IDR" || this.currency == null) {
        this.channelList.push(require("../assets/image/pc/footer/dana.png"),
            require("../assets/image/pc/footer/ovo.png"),
            require("../assets/image/pc/footer/shopeepay.png"),
            require("../assets/image/pc/footer/linkaja.png"),
            require("../assets/image/pc/footer/qris.png"),
            require("../assets/image/pc/footer/astrapay.png"),
            require("../assets/image/pc/footer/bca.png"),
            require("../assets/image/pc/footer/bni.png"),
            require("../assets/image/pc/footer/bri.png"),
            require("../assets/image/pc/footer/cimb.png"),
            require("../assets/image/pc/footer/mandiri.png"),
            require("../assets/image/pc/footer/permata.png"),
            require("../assets/image/pc/footer/alfamart.png"),
            require("../assets/image/pc/footer/credit.png"))

        this.channelMobileList.push(
            require("../assets/image/wap/footer/dana.png"),
            require("../assets/image/wap/footer/ovo.png"),
            require("../assets/image/wap/footer/shopeepay.png"),
            require("../assets/image/wap/footer/linkaja.png"),
            require("../assets/image/wap/footer/qris.png"),
            require("../assets/image/wap/footer/astrapay.png"),
            require("../assets/image/wap/footer/bca.png"),
            require("../assets/image/wap/footer/bni.png"),
            require("../assets/image/wap/footer/bri.png"),
            require("../assets/image/wap/footer/cimb.png"),
            require("../assets/image/wap/footer/mandiri.png"),
            require("../assets/image/wap/footer/permata.png"),
            require("../assets/image/wap/footer/alfamart.png"),
            require("../assets/image/wap/footer/credit.png"))

      } else if(this.currency == "THB") {
        this.channelList.push(require("../assets/image/pc/footer/bay.png"),
            require("../assets/image/pc/footer/bbl.png"),
            require("../assets/image/pc/footer/credit.png"),
            require("../assets/image/pc/footer/kbank.png"),
            require("../assets/image/pc/footer/ktb.png"),
            require("../assets/image/pc/footer/linepay.png"),
            require("../assets/image/pc/footer/promptpay.png"),
            require("../assets/image/pc/footer/scb.png"),
            require("../assets/image/pc/footer/shopee.png"),
            require("../assets/image/pc/footer/truemoney.png"))

        this.channelMobileList.push(require("../assets/image/wap/footer/bay.png"),
            require("../assets/image/wap/footer/bbl.png"),
            require("../assets/image/wap/footer/credit.png"),
            require("../assets/image/wap/footer/kbank.png"),
            require("../assets/image/wap/footer/ktb.png"),
            require("../assets/image/wap/footer/linepay.png"),
            require("../assets/image/wap/footer/promptpay.png"),
            require("../assets/image/wap/footer/scb.png"),
            require("../assets/image/wap/footer/shopee.png"),
            require("../assets/image/wap/footer/truemoney.png"))
      } else if(this.currency == "PHP") {
        this.channelList.push(require("../assets/image/pc/footer/7eleven.png"),
            require("../assets/image/pc/footer/bpi.png"),
            require("../assets/image/pc/footer/cebuana.png"),
            require("../assets/image/pc/footer/gcash.png"),
            require("../assets/image/pc/footer/grabpay.png"),
            require("../assets/image/pc/footer/paymaya.png"),
            require("../assets/image/pc/footer/shopee.png"),
            require("../assets/image/pc/footer/credit.png"),
            require("../assets/image/pc/footer/ubp.png"))

        this.channelMobileList.push(require("../assets/image/wap/footer/7eleven.png"),
            require("../assets/image/wap/footer/bpi.png"),
            require("../assets/image/wap/footer/cebuana.png"),
            require("../assets/image/wap/footer/gcash.png"),
            require("../assets/image/wap/footer/grabpay.png"),
            require("../assets/image/wap/footer/paymaya.png"),
            require("../assets/image/wap/footer/shopee.png"),
            require("../assets/image/wap/footer/credit.png"),
            require("../assets/image/wap/footer/ubp.png"))
      } else if(this.currency == "BRL") {
        this.channelList.push(require("../assets/image/pc/footer/ame.png"),
            require("../assets/image/pc/footer/bank_transfer.png"),
            require("../assets/image/pc/footer/boleto.png"),
            require("../assets/image/pc/footer/mercado_pago.png"),
            require("../assets/image/pc/footer/paypal.png"),
            require("../assets/image/pc/footer/picpay.png"),
            require("../assets/image/pc/footer/pix.png"))

        this.channelMobileList.push(require("../assets/image/wap/footer/ame.png"),
            require("../assets/image/wap/footer/bank_transfer.png"),
            require("../assets/image/wap/footer/boleto.png"),
            require("../assets/image/wap/footer/mercado_pago.png"),
            require("../assets/image/wap/footer/paypal.png"),
            require("../assets/image/wap/footer/picpay.png"),
            require("../assets/image/wap/footer/pix.png"))
      } else if(this.currency == "MXN") {
        this.channelList.push(require("../assets/image/pc/footer/bank_transfer.png"),
            require("../assets/image/pc/footer/oxxo.png"),
            require("../assets/image/pc/footer/paycash.png"))

        this.channelMobileList.push(require("../assets/image/wap/footer/bank_transfer.png"),
            require("../assets/image/wap/footer/oxxo.png"),
            require("../assets/image/wap/footer/paycash.png"))
      } else if(this.currency == "VND") {
        this.channelList.push(require("../assets/image/pc/footer/woori.png"),
            require("../assets/image/pc/footer/momo.png"),
            require("../assets/image/pc/footer/viettelpay.png"),
            require("../assets/image/pc/footer/vnptpay.png"),
            require("../assets/image/pc/footer/shopee.png"),
            require("../assets/image/pc/footer/appota.png"),
            require("../assets/image/pc/footer/zalopay.png"))

        this.channelMobileList.push(require("../assets/image/wap/footer/woori.png"),
            require("../assets/image/wap/footer/momo.png"),
            require("../assets/image/wap/footer/viettelpay.png"),
            require("../assets/image/wap/footer/vnptpay.png"),
            require("../assets/image/wap/footer/shopee.png"),
            require("../assets/image/wap/footer/appota.png"),
            require("../assets/image/wap/footer/zalopay.png"))
      } else if(this.currency == "MYR") {
        this.channelList.push(require("../assets/image/pc/footer/tng.png"),
            require("../assets/image/pc/footer/mcash.png"),
            require("../assets/image/pc/footer/boost.png"),
            require("../assets/image/pc/footer/grabpay.png"),
            require("../assets/image/pc/footer/fpx.png"),
            require("../assets/image/pc/footer/unionpay.png"))

        this.channelMobileList.push(require("../assets/image/wap/footer/tng.png"),
            require("../assets/image/wap/footer/mcash.png"),
            require("../assets/image/wap/footer/boost.png"),
            require("../assets/image/wap/footer/grabpay.png"),
            require("../assets/image/wap/footer/fpx.png"),
            require("../assets/image/wap/footer/unionpay.png"))
      }
    }
  },
}
</script>

<style lang="scss" scoped>
a:hover {
  text-decoration: none;
  opacity: 0.8;
}
img {
  width: 100%;
  height: 100%;
}
p {
  margin-bottom: 0;
}
.footer {
  max-width: 1236px;
  margin: 0 auto;
}
.footer-part1 {
  text-align: left;
  display: flex;
  justify-content: space-between;
  padding-bottom: 32px;
  .logo-hd {
    height: 37px;
    width: auto;
  }
  .contact-more {
    max-width: 564px;
    margin-left: 94px;
  }
  .footer-part1-2 {
    display: flex;
  }
  ul {
    margin-bottom: 0;
    li {
      margin-bottom: 15px;
      color: #666;
      &:last-child {
        margin-bottom: 0;
      }
      p {
        line-height: 25px;;
      }
    }
  }
  .more-wrapper {
    a {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666;
      line-height: 25px;
    }
    .title {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #222222;
      line-height: 25px;
      margin-bottom: 24px;
    }
  }
  .channel-more {
    width: 232px;
  }
  .channel-lists {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 52px;
      height: 26px;
      margin: 0 8px 8px 0;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
.footer-part2 {
  padding-top: 40px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  text-align: center;
  border-top: 1px solid #D5D5D5;

}
.mobile {
  .footer-part1 {
    font-size: px2rem(24);
    padding-bottom: px2rem(50);
    display: block;
    
    .title {
      font-size: px2rem(28);
      margin-bottom: px2rem(41);
      margin-top: .6rem;
    }
    .footer-part1-2 {
      display: block;
    }
    ul {
      li {
        margin-bottom: .4rem;
        a {
          font-size: .22rem;
          color: #222;
        }
      }
    }
    .contact-more {
      width: 100%;
      margin-left: 0;;
      margin-right: 0;
      .contact-lists {
        li {
          &:last-child {
            margin-bottom: px2rem(0);
          }
        }
      }
    }
  }
  .footer-part2 {
    font-size: px2rem(22);
    font-family: PingFang SC;
    font-weight: 400;
    color: #A0A0A0;
    padding: 0;
    border: none;
    text-align: left;
    padding-top: .38rem;
    border-top: .01rem solid #E3E3E3;
  }
  .footer-part3 {
    .links-more-lists {
      display: flex;
      font-size: px2rem(24);
      font-family: PingFang SC;
      font-weight: 400;
      justify-content: center;
      line-height: 1;
      margin-bottom: 0;
      margin-top: px2rem(21);
      li {
        border-left: 1px solid #2E2E2E;
        &:first-child {
          border-left: none;
        }
      }
      a {
        color: #FFFFFF;
        margin: 0 px2rem(20);
        white-space: nowrap;
      }
    }
  }

}

</style>
